import type { FC, SVGProps } from 'react';

const GlucometerIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_17340_2647"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <rect
        x="3.42773"
        y="3.43066"
        width="17.1429"
        height="17.1429"
        fill="url(#pattern0_17340_2647)"
      />
    </mask>
    <g mask="url(#mask0_17340_2647)">
      <rect
        x="-5.14355"
        y="-5.14062"
        width="34.2857"
        height="34.2857"
        fill="currentColor"
      />
    </g>
    <path
      d="M11.7587 2.45002C11.7593 2.44964 11.76 2.44926 11.7606 2.44888C11.8443 2.39936 12.0547 2.41319 12.1052 2.47207L11.7587 2.45002Z"
      fill="currentColor"
    />
    <path
      d="M11.7581 2.44946C11.7326 2.47978 11.6417 2.72604 11.5562 2.99667C11.4162 3.4395 11.1917 3.94739 10.9674 4.32871C8.94595 7.76542 5.30958 10.3735 5.07471 14.6493C5.07895 16.8932 5.93467 19.0714 7.93319 20.3885C10.3562 21.9854 13.497 22.0154 15.9305 20.4115C17.929 19.0944 18.7847 16.9163 18.789 14.6724C18.5541 10.3966 14.9177 7.78846 12.8963 4.35176C12.672 3.97044 12.4475 3.46255 12.3075 3.01972C12.222 2.7491 12.1311 2.50283 12.1056 2.47251L12.1052 2.47207L11.7587 2.45002C11.7593 2.44964 11.76 2.44926 11.7606 2.44888L11.7585 2.44902L11.7581 2.44946Z"
      fill="currentColor"
    />
    <path
      d="M12.1052 2.47207C12.0535 2.38832 11.8224 2.3745 11.7585 2.44902L11.7606 2.44888C11.8443 2.39936 12.0547 2.41319 12.1052 2.47207Z"
      fill="currentColor"
    />
    <path
      d="M8.85071 15.6686L10.1228 17.8264L9.66417 18.6209C9.57792 18.7703 9.6291 18.9614 9.77851 19.0476C9.92793 19.1339 10.119 19.0827 10.2052 18.9333L10.6823 18.107H13.2247L13.7017 18.9333C13.788 19.0827 13.979 19.1339 14.1284 19.0476C14.2778 18.9614 14.329 18.7703 14.2428 18.6209L13.7634 17.7905L15.0143 15.6686H16.0773C16.2498 15.6686 16.3897 15.5288 16.3897 15.3562C16.3897 15.1837 16.2498 15.0438 16.0773 15.0438H15.0622L13.7649 12.8431L14.2428 12.0153C14.329 11.8659 14.2778 11.6748 14.1284 11.5886C13.979 11.5023 13.788 11.5535 13.7017 11.7029L13.2276 12.5242H10.6794L10.2052 11.7029C10.119 11.5535 9.92793 11.5023 9.77851 11.5886C9.6291 11.6748 9.57792 11.8659 9.66417 12.0153L10.1213 12.8072L8.8028 15.0438H7.78775C7.61523 15.0438 7.47537 15.1837 7.47537 15.3562C7.47537 15.5288 7.61523 15.6686 7.78775 15.6686H8.85071ZM13.2536 13.2997L14.4457 15.2492C14.4709 15.2905 14.4709 15.3407 14.4457 15.382L13.2536 17.3315C13.228 17.3733 13.1793 17.4009 13.1246 17.4009H10.7404C10.6857 17.4009 10.637 17.3733 10.6115 17.3315L9.41938 15.382C9.39414 15.3407 9.39414 15.2905 9.41938 15.2492L10.6115 13.2997C10.637 13.2579 10.6857 13.2303 10.7404 13.2303H13.1246C13.1793 13.2303 13.228 13.2579 13.2536 13.2997Z"
      fill="white"
      stroke="white"
      strokeWidth="0.137143"
    />
    <defs>
      <pattern
        id="pattern0_17340_2647"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_17340_2647" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_17340_2647"
        width="90"
        height="90"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADhklEQVR4nO2dzYtNYRzHv2fe/AMYG5EUiZKdcIu1ZEQZomhIZrC1kYWMsJkVMUzedgplYaGZZkGkaJJovCRvMRjMysud/HTyPJvb3Jl773nuOd/fc55PfTa328w5n27nPuc85zwXCAQCAa9pAdAD4Juxx7wWcMw5AFJib6jslo0TRLa2h9humG0OFeVCfwcwN8RORhOAu5NEtt4x7w3UyJEKIlsP1/pP8s5SAH+qCF0EsCzrjdZGE4CHVUS2DgFoznrjNXGohsjWg1lvvBYWAviZIPQvAIuy3gl2GswIQhJ6D0Bj1jvDzH4Hka2dWe8MK63m5MNV6DEAs7LeKUYuOYxsPZ/1TrGxAsDfOoSO/+byrHeOhUYz/pU6+Sh8Mf7nQB0jW/ci57Q6/gIsZ3z1bwZyTG8Kka2nkeMzwGKKocfzesZ4M8XI1mvIGasyiGxdiZwQVThrUi/vm23wnk0ZRra2wXOaATwnCD3s+wTBHoLI1t3wlGYArwkCW9/4+qneSRC31O3w8MLRMEHYUp+ZWR1vaCeIWs54FOQFEYDHBEHLOeTLuHo9QcypXAsPeEAQspKzRdWsIYgoFVqAYm4QBJQKvQqlzDHXgEWJ42ab1XGSIJ5U6VEoI36I5zNBOKnST9pOyzcQRJMaXQdFZDFNJY68DkW3EKQ56SqOjZ8ymAkFdBLEkoTG183pGSAIJQm9DXKmKz9siLFo9oWWHQSRJA+TAlcIAokjL4KY9wSBxJEfQHwvnXjmAhCyjSCMOHYLCDlBEEYcewyE3CIII46NLyXQ8ZQgjDj2CQj5SBBG8jDySPL8tpAa7xMdvwnCiGPjB/jpGCUII479AkKY7hQVR74CIYMEYcSx/SDkDEEYcewpeL7WhpDYBdJVvcQzF4OQyHxLiyeOMN/O20cQSBx5FsSsJggkjoyf7qWlwYw9RbkvmA8bjM8SSo12QAHTlM8dvtW00rrmaa3NUIbGO5YGNRybS5lvFvkTJf4AMA9KYVgyQipU/W8FHCeIOJXd8IDILF0ppF7WeFyebIXzCwRRS+3z8UcYIrLDSLdPn+SJaEtp9cZyjmkcKycZ+g1kNDWldghXKxGArQDepXRarX74lpQWALsAvKzTVbgOTdcu0vqEF8yvvI0kiDtiFpct+P5l54IIwBIA+8wquf3m0zlq7oiK/Wpe6zfv6TJzfCFuIBAIBAIB5Jd/zMyVQVG65LQAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);

export default GlucometerIcon;
